import React from 'react'
import deleteIcon from '../../../assets/images/delete_icon_red.png'
import '../index.scss'
import { useTranslation } from 'react-i18next'
const ManageListTemplateTable = ({
	templates,
	columns,
	handleEditAction,
	handleDeleteAction,
}) => {
	const { t } = useTranslation(['labels'])

	return (
	<>
		<div className='d-none d-lg-block'>
			<table className='table template-table mb-0'>
				<thead>
					<tr>
						{columns && columns.length > 0 ? (
							columns.map((column, columnnIndex) => (
								<th
									className={`table__head-th user-table-th column-head-width-${columnnIndex}`}
									key={columnnIndex}
								>
									<span>{t(column)}</span>
								</th>
							))
						) : (
							<></>
						)}
						<th className='table__head-th actionHead user-table-th'>
							<span>{t('MNGTMPLT.ACTION')}</span>
						</th>
					</tr>
				</thead>
				<tbody>
					{templates &&
						templates.length !== 0 &&
						templates.map((template, templateIndex) => (
							<tr
								key={templateIndex}
								className='editTemplate'
								onClick={(evnt) => handleEditAction(evnt, template)}
							>
								<td className='table__body-td column-body-width-templateName'>
									{template.templateName}
								</td>
								<td className='table__body-td column-body-width-userId'>
									{template.userId}
								</td>
								<td className='table__body-td column-body-width-time'>
									{template.updateTime}
								</td>
								<td className='table__body-td'>
									<img
										src={deleteIcon}
										alt='Delete'
										title={t('COMMON.DELETE')}
										onClick={(evnt) => handleDeleteAction(evnt, template)}
									/>
								</td>
							</tr>
						))}
				</tbody>
			</table>
		</div>
			

		 <div className="table-container d-flex d-lg-none">
			<table className="template-table-mobile">
			<thead>
				<tr>
				{columns && columns.length > 0 ? (
					columns.map((column, columnnIndex) => (
						<th
							
							key={columnnIndex}
						>
							{t(column)}
						</th>
						))
					) : (
						<></>
					)}
				<th >
					{t('MNGTMPLT.ACTION')}
				</th>
				
				</tr>
			</thead>
				<tbody>
				{templates &&
				templates.length !== 0 &&
				templates.map((template, templateIndex) => (
					<tr
						key={templateIndex}
						onClick={(evnt) => handleEditAction(evnt, template)}
					>
						<td className='template-name-cell' >
							{template.templateName}
						</td>
						<td >
							{template.userId}
						</td>
						<td >
							{template.updateTime}
						</td>
						<td >
							<img
								src={deleteIcon}
								alt='Delete'
								title={t('COMMON.DELETE')}
								onClick={(evnt) => handleDeleteAction(evnt, template)}
							/>
						</td>
					</tr>
				))}
							</tbody>
			</table>
    		</div>
	</>
	)
}

export default ManageListTemplateTable
